import { useEffect, useState } from 'react';
import { callMsGraphGroup } from '../../graphGroup';
import { useMsal } from '@azure/msal-react';
import { profileRequest } from '../../authConfig';
import { ProfileType } from '../../model/datatype';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useUser } from '../../context/UserContext';

// is-mobile

export const Topbar = (props: any) => {
  const { instance, accounts } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [graphData, setGraphData] = useState(false);
  const navigate = useNavigate();
  
  // ดึงข้อมูลผู้ใช้จาก context แทน
  const { userInfo, isLoading: userLoading } = useUser();
  
  useEffect(() => {
    console.log(isMobile);
    if (isMobile) {
      navigate('/desktop-olny');
    }
    // ไม่ต้องเรียก API โดยตรงอีก เพราะใช้ context แล้ว
  }, [isMobile, navigate]);

  return (
    <div className="admin-top-bar">
      <div className="row">
        <div className="col-12 col-sm-7 col-md-7"></div>
        <div className="col-12 col-sm-5 col-md-5">
          <div className="user-profile d-flex float-end">
            <div className="text-end me-2 pt-1">
              <label>{userInfo?.employeeNameEn}</label>
              <p>Admin</p>
            </div>
            <div>
              <img src="../../../images/user.png" alt="User profile" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
